import {Store} from '../classes/store';
import {ProjectElement} from '../../../resources/element/project-element.interface';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectElementStore extends Store<ProjectElement> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

  insert(insertItem) {

    // We may get a sloppy copy, this cleans it up a little
    delete insertItem.module;
    delete insertItem.submodule;
    insertItem = JSON.parse(JSON.stringify(insertItem));

    // Pass the new data to the API
    return this.api.addElement(insertItem).then(insertedItem => {

      insertItem = Object.assign(insertItem, insertedItem.element);

      // super.insert(insertItem);
      // We use an alternative way to add the new Element because the array holds order information
      let lastIndex = this.state.map(el =>
        el.submoduleId === insertItem.submoduleId).lastIndexOf(true);

      if (lastIndex === -1) {
        lastIndex = this.state.map(el =>
          el.moduleId === insertItem.moduleId).lastIndexOf(true);
      }

      if (lastIndex >= 0) {
        this.state.splice(lastIndex + 1, 0, insertItem);
      } else {
        this.state.push(insertItem);
      }

      this.setState(this.state);

      return Promise.resolve(insertItem);
    });
  }

  update(updateItem: Partial<ProjectElement> | any): ProjectElement {
    // Update the store and get the full item
    const fullItem = super.update(updateItem);

    // Fix for issue when an item has been added to new datastore, but is unknown in *this* datastore.
    if (!fullItem) {
      return;
    }

    // Add minimally required id's
    updateItem.submoduleId = fullItem.submoduleId;
    updateItem.moduleId = fullItem.moduleId;
    updateItem.projectId = fullItem.projectId;
    updateItem.versionId = fullItem.versionId;

    // Pass the new data to the API
    this.api.patchElement(updateItem);

    return updateItem;
  }

  delete(deleteId) {
    // Update the store and get the full item

    const fullItem = super.delete(deleteId);

    // Pass the new data to the API
    this.api.patchElement(fullItem);

    return fullItem;
  }

  orderByModule(orderedModuleIds) {
    this.state.sort((a, b) => orderedModuleIds.indexOf(a.moduleId) - orderedModuleIds.indexOf(b.moduleId));
    // this.setState(this.state);
  }

  orderBySubmodule(orderedSubmoduleIds) {
    this.state.sort((a, b) => orderedSubmoduleIds.indexOf(a.submoduleId) - orderedSubmoduleIds.indexOf(b.submoduleId));
    // this.setState(this.state);
  }
}
